module.exports = __webpack_public_path__ + "static/media/PickledPink.f3b282d3.mp3";